import { makeStyles, shorthands } from "@fluentui/react-components";
import { customTokens, customTypographyStyles } from "../../theme/theme";

const useMobileHeaderStyles = makeStyles({
  header: {
    backgroundColor: customTokens.UNFCCCPrimaryOcean100,
    color: customTokens.colorNeutralForegroundInverted,
    display: "flex",
    alignItems: "center",
    height: "50px",
    padding: "12px 20px",
    gap: "12px",
  },

  logo: {
    height: "35px",
    width: "118px",
  },

  divider: {
    flex: 0,
    height: "35px",
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    ...shorthands.gap("12px"),
  },

  icon: {
    cursor: "pointer",
    fontSize: "24px",
  },

  searchBar: {
    position: "absolute",
    top: "74px",
    left: 0,
    right: 0,
    boxSizing: "border-box",
    width: "100%",
    background: customTokens.colorNeutralForegroundInverted,
    padding: "10px",
  },

  searchBox: {
    width: "100%",
  },

  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px",
    backgroundColor: "#1D2575",
    color: "#fff",
  },

  drawerLogo: {
    height: "32px",
  },

  closeIcon: {
    color: "#fff",
    cursor: "pointer",
  },

  drawerBody: {
    backgroundColor: customTokens.UNFCCCPrimaryOcean100,
    color: "#fff",
    height: "100%",
    padding: "20px",
  },

  drawerItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 0",
    cursor: "pointer",
    fontWeight: 600,
  },

  unfcccLink: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    padding: "16px 0",
    color: customTokens.colorNeutralForegroundInverted,
    ...customTypographyStyles.body1,

    "&:hover": {
      textDecoration: "underline",
    },
  },

  subMenu: {
    paddingLeft: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "12px",
  },

  disabled: {
    color: customTokens.UNFCCCPrimaryOcean90,
    cursor: "not-allowed",
  },
});

export default useMobileHeaderStyles;
